import React from "react";

export const HydrogenForIndustry = [
  <>
    <h4 className="slideTitle">
      Hydrogen for industry as means for decarbonization efficiency
    </h4>
    <div className="slideContainer slide_solidColour">
      <p>
        Hydrogen is playing an increasing role within the renewable power system
        and in driving operational efficiencies for greater throughout.
      </p>
    </div>
    <div className="slideContainer slide_solidColour">
      <div className="colLeft col50">
        <p>
          <strong>
            Enable deep renewables penetration, distribution and system
            resilience
          </strong>
        </p>
      </div>
      <div className="colRight col50">
        <p>
          <strong>
            Green hydrogen used to decarbonize hard-to-abate end-uses
          </strong>
        </p>
      </div>
    </div>
    <div className="col100">
      <img
        alt=""
        class=""
        src="images/H2IndustriesEfficiency.JPG"
        width="100%"
        height="auto"
      />
    </div>
  </>,
  <div className="slideContainer slide_solidColour">
    <div className="colLeft col50">
      <h4 className="slideTitle">
        Creating a clean hydrogen market to serve industries and power
      </h4>
      <p>
        Hydrogen is playing an increasing role within the renewable power system
        and decarbonization of energy use replacing coal and other fossil fuels.
      </p>
      <ul className="shell_bullets_list">
        <li>
          We have been an early investor in Hydrogen production. Currently we
          have <strong>five large electrolyser projects</strong> globally for
          green Hydrogen powered industry, one of which is RefHyne.
        </li>
        <li>
          Inaugurated in July 2021, <strong>RefHyne</strong> is a 10-megawatt
          PEM (polymer = electrolyte membrane) electrolyser -the largest of its
          kind- , to produce hydrogen at the Rhineland refinery in Germany.
        </li>
        <li>
          Supported by the European Union, the project could be{" "}
          <strong>scaled up to 100 megawatt over time</strong> with ITM Power.
        </li>
      </ul>
    </div>
    <div className="colRight col50">
      <img
        alt=""
        class=""
        src="images/H2IndustriesPower.JPG"
        width="100%"
        height="auto"
      />
    </div>
  </div>,
  // <>
  //   <h4 className="slideTitle">Hydrogen industry projects footprint</h4>
  //   <div className="slideContainer slide_solidColour">
  //     <div className="colLeft col50 solidColourContainer stats">
  //       <p className="figureContainer">
  //         <span className="figure">3</span>{" "}
  //         <strong>existing electrolysers</strong> in the UK, Germany and China.
  //       </p>
  //       <p className="figureContainer">
  //         <span className="figure">5</span>{" "}
  //         <strong>large electrolyser projects</strong> globally for green
  //         Hydrogen powered industry, next to
  //       </p>
  //     </div>
  //     <div className="colRight col50">
  //       <img src="images/H2IndustriesProjects.JPG" width="100%" height="auto" />
  //       <img src="images/H2IndustriesKey.JPG" width="50%" height="auto" />
  //     </div>
  //   </div>
  // </>,
    <>
    <h4 className="slideTitle">Decarbonizing heavy industry with hydrogen solutions starts at the hubs</h4>
    <div className="slideContainer slide_solidColour">
      <div className="colLeft col50">
        <p>Shell aims to serve big industrial clusters to help decarbonize their businesses. We get started by serving our own anchor demand in e.g. refineries, expanding to local hub demand close to the supply and finally connecting to large industry hubs when the infrastructure becomes available.
        </p>
        <img src="images/H2Industries-proofPoints.jpg" width="100%" height="auto" />
      </div>
      <div className="colRight col50">
        <img src="images/H2Industries-map.jpg" width="100%" height="auto" />
      </div>
    </div>
  </>,
];
